import React from "react";
import { NavLink } from "react-router-dom";
import { ReactComponent as RightArrow } from "./icons/arrow-right.svg";
import "../App.css";

function RightTextArrow(props) {
  return (
    <div className="FooterSection Right">
      <NavLink className="FooterLinks-link" to={props.to}>
        <div className="FooterLinks-text">{props.text}</div>
        <div>
          <RightArrow className="FooterLinks-arrow" fill="#FF900A" />
        </div>
      </NavLink>
    </div>
  );
}

function LeftTextArrow(props) {
  return (
    <div className="FooterSection Left">
      <NavLink className="FooterLinks-link" to={props.to}>
        <div>
          <RightArrow
            className="FooterLinks-arrow"
            fill="#FF900A"
            transform="rotate(180)"
          />
        </div>
        <div className="FooterLinks-text">{props.text}</div>
      </NavLink>
    </div>
  );
}

function FooterLinks(props) {
  let className = "FooterLinks";
  if (props.next && !props.back) {
    className += " FooterLinks-rightOnly";
  }

  return (
    <div className={className}>
      {props.back && (
        <LeftTextArrow to={props.back.to} text={props.back.text} />
      )}
      {props.next && (
        <RightTextArrow to={props.next.to} text={props.next.text} />
      )}
    </div>
  );
}

export default FooterLinks;
